import React from "react";
import useInitPortalizedModalContext from "./../hooks/useInitPortalizedModalContext";
import PortalizedModal from "../components/PortalizedModal";

let PortalizedModalContext;
const { Provider } = (PortalizedModalContext = React.createContext());

const PortalizedModalProvider = ({ children }) => {
  const { modal, openModal, closeModal, content, setModalContent } = useInitPortalizedModalContext();
  return (
    <Provider value={{ modal, openModal, closeModal, content, setModalContent }}>
      <PortalizedModal />
      {children}
    </Provider>
  );
};

export { PortalizedModalContext, PortalizedModalProvider };
